import { UPGRADE_L2, UPGRADE_L3 } from './tables';
import { pushLedger } from './ledger';
import { emptyLog } from './hollowLog';
import { addTrickStock, ROAD_TRICK_GRANT } from './trickStock';
import { ensureCharms, grantWelcomePack } from '../charms/stake';
import type { Profile } from './types';

export const ECONOMY_REV = 2;

/**
 * Honey ×10, trick levels refunded, owned tricks become a stack of 5,
 * and a welcome Charm pack. Runs once, when `economyRev` is missing.
 */
export function migrateEconomy(profile: Profile, now: number): boolean {
  if (profile.economyRev === ECONOMY_REV) return false;
  const honeyBefore = profile.wallet.honey;
  profile.wallet.honey = honeyBefore * 10;
  let refund = 0;
  if (!profile.trickStock) profile.trickStock = {};
  for (const [id, owned] of Object.entries(profile.tricks)) {
    if (!owned) continue;
    if (owned.level >= 2) refund += UPGRADE_L2;
    if (owned.level >= 3) refund += UPGRADE_L3;
    owned.level = 1;
    if (profile.trickStock[id] === undefined) addTrickStock(profile, id, ROAD_TRICK_GRANT);
  }
  if (refund > 0) profile.wallet.acorns += refund;
  ensureCharms(profile);
  grantWelcomePack(profile);
  if (!profile.log) profile.log = emptyLog();
  profile.economyRev = ECONOMY_REV;
  if (honeyBefore > 0) pushLedger(profile, now, 'migration', { honey: honeyBefore * 9 }, 0, 'honey-x10');
  if (refund > 0) pushLedger(profile, now, 'migration', { acorns: refund }, 0, 'upgrade-refund');
  pushLedger(profile, now, 'charm', {}, 0, 'welcome-pack');
  return true;
}
